let timer;
let timer2;
let throttle = 500; // ms
/**
 * A custom onInit function that will cycle and check for the PureChat Box
 * which has a varying load time. Adding accessibility where needed.
 * Once the query passes the if() check, the interval/ cycle will terminate.
 */
function pureChatBtnCheck() {
	if (document.querySelector("[data-trigger='superMinimize']")) {
		const pureChatMinimize = document.querySelector("[data-trigger='superMinimize']");
		pureChatMinimize.setAttribute('title', 'PureChat Minimize');
		clearInterval(timer);
	}
}

function controlDotsCheck() {
	if (document.querySelector('.feedback__carousel__block .control-dots')) {
		const carouselDots = document.querySelector('.feedback__carousel__block .control-dots');
		if (carouselDots.querySelectorAll('li')) {
			const elements = carouselDots.querySelectorAll('li');
			const elementArray = Object.keys(elements);
			elementArray.forEach((ele, index) => {
				elements[index].removeAttribute('role');
			});
			clearInterval(timer2);
		}
	}
}
function onInit() {
	timer = setInterval(pureChatBtnCheck, throttle);
	timer2 = setInterval(controlDotsCheck, throttle);
}
onInit();